// src/store/thunks/sixDetail/toggleFileFavoriteThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { fetchFilesThunk } from '@/store/thunks/sixDetail/fetchFilesThunk';
import type { SixFileFavoriteDTO } from '@/types/SixCatalogDTOs';
import { withErrorHandling, withLoader } from "@/store/thunks/thunkWrappers";

export const toggleFileFavoriteThunk = createAppAsyncThunk<
  SixFileFavoriteDTO,
  { sixId: string; fileId: string }
>(
  'sixDetail/toggleFileFavorite',
    withLoader(
      withErrorHandling(
  async({ sixId, fileId }, { extra, dispatch }) => {
    const resp = await extra.sixDetailService.toggleFileFavorite(sixId, fileId);
    await dispatch(fetchFilesThunk({ sixId })).unwrap();
    return resp;
  }))
);
